import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { MessageService } from "../message.service";

@Injectable({
    providedIn: 'root'
})

export class RegisterService {

    private registerUrl = location.origin + '/api/user/register/';

    private token = localStorage.getItem('token');

    private headers = new HttpHeaders().set('Content-Type', 'application/json');
    httpOptions = this.headers.append('Authorization', `Bearer ${this.token}`);
    //httpOptions: HttpHeaders | { [header: string]: string | string[]; };

    constructor(private http: HttpClient, private messageService: MessageService) { }

    getToken() {
        return this.headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    }

    emailCheck(email: string): Observable<any> {

        return this.http.get<any>(`${this.registerUrl}check/${email}`);
    }

    userRegistration(details): Observable<any> {
        console.log(details);
        return this.http.post<any>(`${this.registerUrl}`, details)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getActivateVerifiedUser(activationCode): Observable<any> {
        return this.http.get<any>(`${this.registerUrl}activate/${activationCode}`)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getEmailVerified(email): Observable<any> {

        return this.http.get<any>(`${this.registerUrl}verify/${email}`,)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getRegisteredUser(): Observable<any> {
        return this.http.get<any>(`${this.registerUrl}get`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getCompletionResultForRegisterUser(): Observable<any> {
        return this.http.get<any>(`${this.registerUrl}complete/check`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    

    getUserPersonalDetail(registrationId): Observable<any> {
        return this.http.get<any>(`${this.registerUrl}personal-detail/${registrationId}`)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    addUserPersonalDetail(registrationId, personalDetail): Observable<any> {
        return this.http.post<any>(`${this.registerUrl}personal-detail/${registrationId}`, personalDetail, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    createHrweUser(registrationId): Observable<any> {
        return this.http.get<any>(`${this.registerUrl}complete/${registrationId}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getUserCompanyDetail(registrationId): Observable<any> {
        return this.http.get<any>(`${this.registerUrl}company-detail/${registrationId}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    addUserCompanyDetail(registrationId, companyDetail): Observable<any> {
        return this.http.post<any>(`${this.registerUrl}company-detail/${registrationId}`, companyDetail, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }


    getUserContractDocument(registrationId): Observable<any> {
        return this.http.get<any>(`${this.registerUrl}contract-document/${registrationId}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    addUserContractDocument(registrationId, contractDocument): Observable<any> {
        return this.http.post<any>(`${this.registerUrl}contract-document/${registrationId}`, contractDocument, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

}